import _OEM from "./OEM";
var exports = {};
const OEM = _OEM;
exports = {
  defaultOEM: OEM.DEFAULT
};
export default exports;